import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import globalLoading from "./globalLoading.module";
import dialog from "./dialog.module";
import toast from "./toast.module";
import help from "./help.module";
import * as entities from "./entities";

Vue.use(Vuex);

let store = new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    globalLoading,
    dialog,
    toast,
    help,
    ...entities
  }
});

export default store;
